export default __webpack_public_path__ + "static/media/banner-1.9fbf81e2.jpg";